<template>
  <div>
    <section class="section">
      <div class="container">
        <BaseTitle>
          Connexion
        </BaseTitle>

        <PendingAction />

        <form
          class="max-w-md m-auto"
          @submit.prevent="submit"
        >
          <b-field label="Email">
            <b-input
              v-model="email"
              type="email"
              placeholder="Email"
              required
            />
          </b-field>
          <b-field
            class="mb-8"
            label="Mot de passe"
          >
            <b-input
              v-model="password"
              type="password"
              placeholder="Mot de passe"
              required
            />
          </b-field>
          <div class="text-center">
            <b-button
              type="is-primary"
              native-type="submit"
              class="mb-4"
            >
              Connexion
            </b-button>
            <div>Pas encore de compte?</div>
            <div>
              <b-button
                type="is-text"
                tag="router-link"
                to="/inscription"
              >
                Créer un compte
              </b-button>
              <b-button
                type="is-text"
                tag="router-link"
                to="/oubli-mot-de-passe"
              >
                Mot de passe oublié
              </b-button>
            </div>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapActions } from 'vuex';
import BaseTitle from '../components/BaseTitle.vue';
import PendingAction from './partials/PendingAction.vue';

export default {
  name: 'SignIn',
  components: {
    BaseTitle,
    PendingAction,
  },
  computed: mapFields('authentication', ['form.email', 'form.password']),
  methods: {
    ...mapActions('authentication', ['signIn']),
    submit() {
      this.signIn()
        .then(() => {
          this.$router.replace(this.$route.query.redirect || '/');
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$buefy.toast.open({
              message: 'Identifiants incorrects',
              type: 'is-danger',
              position: 'is-bottom',
              duration: 5000,
            });
          }
        });
    },
  },
};
</script>
